var map = {
	"./auth.js": 578,
	"./category.js": 8792,
	"./complain.js": 3871,
	"./dashboard.js": 7346,
	"./global.js": 363,
	"./inspector.js": 743,
	"./merchant.js": 1248,
	"./order.js": 5293,
	"./product.js": 3649,
	"./school.js": 1864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7220;